module.exports = __webpack_public_path__ + "img/2X.2.ca8b19e5.jpg";